import type { RegisterProps } from "../data-types";

const optionsFromObj = function (
  data: Array<any>,
  valueKey: string,
  displayKey: string,
) {
  return data.map((item: any) => (
    <option key={item[valueKey]} value={item[valueKey]}>
      {item[displayKey]}
    </option>
  ));
};

export type ObjectProps = {
  [x: PropertyKey]: any;
  className?: string;
  data: any;
  displayArrow?: boolean;
  displayKey: string;
  hasErrors?: boolean;
  name: string;
  placeholderText?: string;
  selectedValue?: string;
  valueKey: string;
  registerProps: RegisterProps;
};

export default function SelectFromObject({
  className = "",
  data,
  displayArrow = true,
  displayKey,
  hasErrors = false,
  name,
  placeholderText,
  selectedValue,
  valueKey,
  registerProps,
  ...rest
}: ObjectProps) {
  return (
    <select
      aria-invalid={hasErrors}
      className={`kup-select ${hasErrors ? "kup-select-has-errors" : ""} ${
        displayArrow ? "kup-select-arrow" : ""
      } ${className}`}
      defaultValue={selectedValue}
      id={name}
      {...registerProps}
      {...rest}
    >
      {placeholderText && <option value="">{placeholderText}</option>}
      {optionsFromObj(data, valueKey, displayKey)}
    </select>
  );
}
